import { ResourceMarker } from "@/interfaces/resource_marker"

export const resourceCardTemplate = (resource: ResourceMarker) => `
  <div class="card bg-base-100 shadow cursor-pointer hover:shadow-lg transition-shadow duration-300"
       data-action="click->resources-map#openResourceModal"
       data-id="${resource.id}"
       data-lat="${resource.latitude}"
       data-lng="${resource.longitude}">
    <div class="card-body">
      <h2 class="card-title text-lg">${resource.info.name}</h2>

      ${resource.info.categories.length ? `
        <div class="flex flex-wrap gap-1 mt-2">
          ${resource.info.categories.map(category => `
            <span class="badge badge-sm badge-primary badge-outline">
              ${category.name}
            </span>
          `).join('')}
        </div>
      ` : ''}

      ${resource.info.address ? `
        <p class="text-sm text-gray-600">
          ${resource.info.address}
        </p>
      ` : ''}

    </div>
  </div>
`
